import { createUseStyles } from "react-jss";
import {breakpoints} from "../../../../constants/breakpoints";
import {colors} from "../../../../constants/colors";

const styles = createUseStyles({
  membersGrid: {
    margin: "24px 0 0 0",
    [`@media (max-width: ${breakpoints.md}px)`]: {
      margin: "24px -32px",
    },
    [`@media (max-width: ${breakpoints.sm}px)`]: {
      margin: "24px -16px",
    },
    "& .rdt_TableRow": {
      "& >div:last-child": {
        //position: "relative !important",
        right: "0px",
        backgroundColor: "inherit",
        //justifyContent: "flex-end"
      }
    },
    "& .rdt_TableCell": {
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: "155px"
    },
    "& .rdt_TableCol": {
      paddingLeft: "16px",
      paddingRight: "16px",
      minWidth: "155px",
      whiteSpace: "nowrap"
    },
    "& .rdt_TableCol:last-child": {
      minWidth: "initial"
    },
    "& .rdt_TableCell:last-child": {
      paddingRight: "16px",
      minWidth: "initial"
    },
  },
  noActionsStyle: {
    "& .rdt_TableRow": {
      "& >div:last-child": {
        justifyContent: "flex-start"
      }
    },
  },
  roleName: {
    fontSize: "14px",
    color: colors.mediumGrey,
    fontWeight: "400",
    lineHeight: "20px",
  }
});

export default styles;
